import { useEffect, useState } from 'react';
import { loadBrandingData } from '../components/OwnezzyLogo';

// Ownezzy's contact, used in the Terms, the Privacy Policy (Grievance Officer) and every "chat with us" link. A Super
// Admin sets it (admin panel: Settings -> Configuration -> Ownezzy contact); these are used until it has loaded.
export const LEGAL_CONTACT = {
  email: 'contact@ownezzy.com',
  operator: 'Akash Kumar Verma', // the person who runs Ownezzy (sole proprietor), named in the policies and on Contact
  whatsapp: '+91 88937 25078',
  whatsappNumber: '918893725078',
  lastUpdated: '27 October 2026',
};

// 918893725078 -> "+91 88937 25078"
const shown = (digits) => (digits.length === 12 && digits.startsWith('91') ? `+91 ${digits.slice(2, 7)} ${digits.slice(7)}` : `+${digits}`);

// { email, whatsapp (as shown), whatsappNumber (digits, for wa.me links), lastUpdated }
export function useOwnezzyContact() {
  const [contact, setContact] = useState(LEGAL_CONTACT);
  useEffect(() => {
    let live = true;
    loadBrandingData().then(({ contact: saved }) => {
      if (!live || !saved) return;
      const digits = String(saved.whatsapp || '').replace(/\D/g, '');
      setContact({
        ...LEGAL_CONTACT,
        // An old address still saved in the settings is replaced by the current one
        email: saved.email && saved.email !== 'ownezzyapp@gmail.com' ? saved.email : LEGAL_CONTACT.email,
        ...(digits.length >= 11 ? { whatsapp: shown(digits), whatsappNumber: digits } : {}),
      });
    });
    return () => { live = false; };
  }, []);
  return contact;
}

// A WhatsApp chat with Ownezzy, the message already typed
export const whatsappLink = (contact, message) => `https://wa.me/${contact.whatsappNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
